import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { z } from 'zod';

import { RouterContext } from '~/types/router.type';

import { CallOffDetails } from '~/modules/callOff/single';

import { getSchemaDefaults } from '@vestigas/utils';
import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

import { getCallOff } from './-routeParams';

const title = i18n.t(($) => $.pageTitle, { callOffNumber: '', ns: 'callOff' });

const zodCallOffSearchParamsSchema = z.object({
  viewAttachmentId: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/(main)/demand/call-offs/$callOffId/')({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/call-offs/$callOffId/',
    ...routeParams,
  }),
  component: CallOffDetails,
  head: ({ loaderData }: { loaderData?: RouterContext }) =>
    getRouteHead(
      `${title} ${loaderData?.pageData?.title ?? ''}`,
      'Rufe Material aus Verträgen ab',
    ),
  loader: async ({ context, params }) => {
    const callOffContext = await getCallOff({ context, params });
    return callOffContext;
  },
  search: {
    middlewares: [
      stripSearchParams(getSchemaDefaults(zodCallOffSearchParamsSchema)),
    ],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodCallOffSearchParamsSchema,
});

export const DEMAND_CALLOFF = buildRouteExport({ Route, ...routeParams });
